
export default function CaseSummary({ selectedCase, firms, domains }) {
  const complainantlc = firms.find(
    (firm) => firm.firmid === parseInt(selectedCase.complainantlc, 10)
  );
  const registrantlc = firms.find(
    (firm) => firm.firmid === parseInt(selectedCase.registrantlc, 10)
  );
  const caseDomains = domains.filter(
    (domain) => domain.caseid === selectedCase.caseid
  );
  return (
    <>
      <h5 className="uppercase text-[#ef8d23] font-bold">Case Details Summary</h5>

      <div  id="summary">

        <table>
          <tbody>
          <tr>
              <th colSpan={2} className="bg-[#ef8d23] text-white">
                {selectedCase.casenumber} CASE SUMMARY
              </th>
            </tr>
            <tr>
              <th colSpan={2} className="bg-dark text-white">
                Case Details
              </th>
            </tr>
            <tr>
              <td >
                {" "}
                <p className="font-bold">Case Lodgement Date</p>
                <p>{selectedCase.casedate}</p>
              </td>
              <td>
                {" "}
                <p className="font-bold">Reference Number</p>
                <p>{selectedCase.rt}</p>
              </td>
            </tr>

            <tr>
              <td>
                <p className="font-bold">Complainant</p>
                <p>{selectedCase.complainant}</p>{" "}
              </td>
              <td>
                {" "}
                <p className="font-bold">Registrant</p>
                <p>{selectedCase.registrant}</p>
              </td>
            </tr>
            <tr>
              <td>
                {" "}
                <p className="font-bold">Complainant Email</p>
                <p>{selectedCase.complainantemail}</p>
              </td>
              <td>
                {" "}
                <p className="font-bold">Registrant Email</p>
                <p>{selectedCase.registrantemail}</p>
              </td>
            </tr>
            <tr>
              <td>
                {" "}
                <p className="font-bold">Complainant Legal Council</p>
                <p>{complainantlc ? complainantlc.firm : "No legal council captured"}</p>
              </td>
              <td>
                {" "}
                <p className="font-bold">Registrant Legal Council</p>
                <p>
                  {registrantlc
                    ? registrantlc?.firm
                    : "No legal council captured"}
                </p>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <p className="font-bold">Domains</p>
                {caseDomains.map((domain) => {
                  return (
                    <p>
                      {domain.domainname} - {domain.decisiontype2}
                    </p>
                  );
                })}
              </td>
            </tr>

            <tr>
              <th colSpan={2} className="bg-dark text-white">
                Commencement
              </th>
            </tr>
            <tr>
              <td>
                <p className="font-bold">Payment Request Date</p>
                <p>{selectedCase.paymentreqdate}</p>
              </td>
              <td>
                {" "}
                <p className="font-bold">Payment Confirmation Date</p>
                <p>{selectedCase.paymentnotdate}</p>
              </td>
            </tr>
            <tr>
              <td>
                <p className="font-bold">Adjudicator Panel</p>
                <p>{selectedCase.adjpanelreq}</p>
              </td>
              <td>
                {" "}
                <p className="font-bold">Reference Number</p>
                <p>{selectedCase.registryrt}</p>
              </td>
            </tr>
            <tr>
              <td>
                {" "}
                <p className="font-bold">Suspension Request Date</p>
                <p>{selectedCase.susprdate}</p>
              </td>
              <td>
                <p className="font-bold">Suspension Date</p>
                <p>{selectedCase.suspdate}</p>
              </td>
            </tr>
            <tr>
              <td>
                <p className="font-bold">Dispute Deficient</p>
                <p>{selectedCase.disputedeficient === 0 && "No" }</p>
                <p>{selectedCase.disputedeficient === 1 && "Yes" }</p>
              </td>
              <td>
                {" "}
                <p className="font-bold">Dispute Deficient Not. Date</p>
                <p>{selectedCase.dispnotdate}</p>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                {" "}
                <p className="font-bold">Dispute Deficient Compliance Date</p>
                <p>{selectedCase.dispdefcompld}</p>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                {" "}
                <p className="font-bold">Dispute Deficient Details</p>
                <p>{selectedCase.dispdefdtls}</p>
              </td>
            </tr>
            <tr>
              <td>
                {" "}
                <p className="font-bold">Registrant Email</p>
                <p>{selectedCase.registrantemail}</p>
              </td>
              <td>
                {" "}
                <p className="font-bold">Registrant Legal Council</p>
                <p>{registrantlc ? registrantlc.firm : ""}</p>
              </td>
            </tr>
            <tr>
              <td>
                <p className="font-bold">Response Deadline</p>
                <p>{selectedCase.responsedld}</p>
              </td>
              <td>
                <p className="font-bold">Commencement Date</p>
                <p>{selectedCase.commdate}</p>
              </td>
            </tr>
            <tr>
              <th colSpan={2} className="bg-dark text-white">
                Response Extension
              </th>
            </tr>
            <tr>
              <td>
                <p className="font-bold">Response Extension</p>
                <p>{selectedCase.extension === 0 && "No"}</p>
                <p>{selectedCase.extension === 1 && "Yes"}</p>
              </td>
              <td>
                {" "}
                <p className="font-bold">Response Extension Request Date</p>
                <p>{selectedCase.extdr}</p>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <p className="font-bold">Response Extension Details</p>
                <p>{selectedCase.extdet}</p>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <p className="font-bold">Extension Notice Date</p>
                <p>{selectedCase.extnotice}</p>
              </td>
            </tr>
            <tr>
              <th colSpan={2} className="bg-dark text-white">
                Settlement
              </th>
            </tr>
            <tr>
              <td>
                <p className="font-bold">
                  Possible Settlement Notification Date
                </p>
                <p>{selectedCase.posettlenotd}</p>
              </td>
              <td>
                {" "}
                <p className="font-bold">Settlement Agreement Deadline</p>
                <p>{selectedCase.settleagreedl}</p>
              </td>
            </tr>
            <tr>
              <td>
                {" "}
                <p className="font-bold">Settled</p>
                <p>{selectedCase.settled === 1 && "Yes" }</p>
                <p>{selectedCase.settled === 0 && "No" }</p>
              </td>
              <td>
                {" "}
                <p className="font-bold">Settlment Agreement Received Date</p>
                <p>{selectedCase.settleagreerecd}</p>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                {" "}
                <p className="font-bold">Settle Date</p>
                <p>{selectedCase.settledate}</p>
              </td>
            </tr>
            <tr>
              <th colSpan={2} className="bg-dark text-white">
                Response
              </th>
            </tr>
            <tr>
              <td>
                <p className="font-bold">Response Default</p>
                <p>{selectedCase.respdefault === 1 && "Yes" }</p>
                <p>{selectedCase.respdefault === 0 && "No" }</p>
              </td>
              <td>
                {" "}
                <p className="font-bold">Response Default Notification Date</p>
                <p>{selectedCase.respdefnotd}</p>
              </td>
            </tr>
            <tr>
              <td>
                <p className="font-bold">Response Deficient</p>
                <p>{selectedCase.respdeficient === 1 && "Yes" }</p>
                <p>{selectedCase.respdeficient === 0 && "No" }</p>
              </td>
              <td>
                <p className="font-bold">
                  Response Deficient Notification Date
                </p>
                <p>{selectedCase.respdefnd}</p>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                {" "}
                <p className="font-bold">Response Deficient Deadline</p>
                <p>{selectedCase.respdefdl}</p>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                {" "}
                <p className="font-bold">Response Deficient Details</p>
                <p>{selectedCase.respdefdet}</p>
              </td>
            </tr>
            <tr>
              <td>
                {" "}
                <p className="font-bold">Response Received</p>
                <p>{selectedCase.resprec === 1 && "Yes" }</p>
                <p>{selectedCase.resprec === 0 && "No" }</p>
              </td>
              <td>
                <p className="font-bold">Response Received Date</p>
                <p>{selectedCase.respdate}</p>
              </td>
            </tr>

            <tr>
              <th colSpan={2} className="bg-dark text-white">
                Reply
              </th>
            </tr>
            <tr>
              <td colSpan={2}>
                <p className="font-bold">Reply Deadline</p>
                <p>{selectedCase.replydl}</p>
              </td>
            </tr>
            <tr>
              <td>
                <p className="font-bold">Reply Extension</p>
                <p>{selectedCase.replyextension === 0 && "No" }</p>
                <p>{selectedCase.replyextension === 1 && "Yes" }</p>
              </td>
              <td>
                {" "}
                <p className="font-bold">Reply Extension Request Date</p>
                <p>{selectedCase.repextrqdt}</p>
              </td>
            </tr>
            <tr>
              <td>
                <p className="font-bold">
                  Reply Extension Notification Date
                </p>
                <p>{selectedCase.replxnotd}</p>
              </td>
              <td>
                <p className="font-bold">Reply Extension Deadline</p>
                <p>{selectedCase.repextdldt}</p>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                {" "}
                <p className="font-bold">Reply Extension Details</p>
                <p>{selectedCase.repextdet}</p>
              </td>
            </tr>
            <tr>
              <td>
                <p className="font-bold">Reply Default</p>
                <p>{selectedCase.replydefault === 0 && "No" }</p>
                <p>{selectedCase.replydefault === 1 && "Yes" }</p>
              </td>
              <td>
                {" "}
                <p className="font-bold">Reply Default Date</p>
                <p>{selectedCase.replydefaultd}</p>
              </td>
            </tr>
            <tr>
              <td>
                {" "}
                <p className="font-bold">Reply Deficient</p>
                <p>{selectedCase.replydeficient === 0 && "No" }</p>
                <p>{selectedCase.replydeficient === 1 && "Yes" }</p>
              </td>
              <td>
                <p className="font-bold">Reply Deficient Notice Date</p>
                <p>{selectedCase.replydeficientnd}</p>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <p className="font-bold">Reply Deficient Deadline</p>
                <p>{selectedCase.replydefdl}</p>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                {" "}
                <p className="font-bold">Reply Deficient Details</p>
                <p>{selectedCase.replydeficientdet}</p>
              </td>
            </tr>
            <tr>
              <td>
                {" "}
                <p className="font-bold">Reply Received</p>
                <p>{selectedCase.replyreceived === 0 && "No" }</p>
                <p>{selectedCase.replyreceived === 1 && "Yes" }</p>
              </td>
              <td>
                <p className="font-bold">Reply Received Date</p>
                <p>{selectedCase.replyrecdt}</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}
